import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';

import AppView from '../../pro/AppView.vue';
import ChartView from '../../pro/ChartView.vue';
import ChartShow from '../../pro/ChartShow.vue';
import MyChartList from '../../pro/MyChartList.vue';
import MyNoteList from '../../pro/MyNoteList.vue';
import PrashnaView from '../../pro/PrashnaView.vue';
import PrashnaShow from '../../pro/PrashnaShow.vue';
import SettingsView from '../../pro/SettingsView.vue';
import SubsView from '../../pro/SubsView.vue';

// Define routes
const routes = [
  {
    name: 'home',
    path: '/',
    component: ChartView
  },
  {
    name: 'charts',
    path: '/charts',
    component: MyChartList
  },
  {
    name: 'notes',
    path: '/notes',
    component: MyNoteList
  },
  {
    name: 'show',
    path: '/show/:hash_id',
    component: ChartShow
  },
  {
    name: 'show-note',
    path: '/show/:hash_id/:note_id',
    component: ChartShow
  },
  {
    name: 'prashna-view',
    path: '/prashna',
    component: PrashnaView
  },
  {
    name: 'prashna',
    path: '/prashna/show/:hash_id',
    component: PrashnaShow
  },
  {
    name: 'settings',
    path: '/settings',
    component: SettingsView
  },
  {
    name: 'subscription',
    path: '/subscription',
    component: SubsView
  }
];

// Create router
const router = createRouter({
  history: createWebHistory(),
  routes
});

// Create and mount the app
const app = createApp(AppView);
app.use(router);
app.config.productionTip = false;
app.mount('.vue-pro-app-view');
